import React, { useState } from "react";
import { Footer } from "./Components/Footer.jsx";
import { Navbar } from "./Components/Navbar.jsx";
import { Routes } from "./Components/Routes.jsx";

const App = () => {
  const [darkTheme, setDarkTheme] = useState(true);

  return (
    <div className={darkTheme ? "dark" : ""}>
      <div className="dark:bg-gray-900 bg-gray-100 dark:text-gray-200 black min-h-screen">
        <Navbar setDarkTheme={setDarkTheme} darkTheme={darkTheme} />
        <Routes />
        <Footer />
      </div>
    </div>
  );
};

export default App;
